import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { getPlayers, getLeague, setAuctionTeam } from '../../data';
import { CircularProgress, makeStyles } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {TextField, Grid, Button, Select, InputLabel} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import { Alert, AlertTitle } from '@material-ui/lab';

function AuctionSubs(props) {
    const leagueID = props.match.params.leagueID;
    const [loading, setLoading] = useState(true);
    const [playerBios, setPlayerBios] = useState([]);
    const [league, setLeague] = useState(undefined);
    const [squad, setSquad] = useState([]);
    const [error, setError] = useState(undefined);
    const [success, setSuccess] = useState(undefined);
    const [saveEnabled, setSaveEnabled] = useState(false);
    useEffect(() => {
        const f = async function() {
            const league = await getLeague(leagueID);
            setLeague(league);
            setSquad(league['teams']);
            const bios = await getPlayers(league['tournament'], leagueID);
            setPlayerBios(bios['players']);
            setLoading(false);
        };
        f();
    }, []);
    const useStyles = makeStyles((theme) => ({
        root: {
            display: 'flex',
            justifyContent: 'center',
        },
        grid: {
            maxWidth: 600,
            alignSelf: 'center',
            flex: 'auto',
        },
        gridItem: {
            display: 'flex',
        },
        select: {
            marginTop: theme.spacing(2),
            minWidth: 300,
        }
    }));
    const classes = useStyles();
    const validate = () => {
        const playersRaw = document.getElementById('players').value;
        const lines = playersRaw.split('\n');
        const players = [];
        const errors = [];
        for (var i = 0;i < lines.length;i++) {
            const name = lines[i].trim();
            const options = playerBios
                .filter(p => p.name.toLocaleLowerCase() === name.toLocaleLowerCase());
            if (options.length !== 1) {
                errors.push(`Error searching for ${name}. num options = ${options.length}.`)
            } else {
                players.push(options[0]['id']);
            }
        }
        if (errors.length !== 0) {
            setError(errors.join('\n'));
            setSaveEnabled(false);
            return [];
        } else {
            setSaveEnabled(true);
            return players;
        }
    };

    const saveTeam = async function() {
        const gameWeek = document.getElementById('gameweek').value;
        const teamName = document.querySelector('#team-name').value;
        const players = validate();
        try {
            const data = await setAuctionTeam(leagueID, teamName, gameWeek, players);
            if (data.error) {
                setError(`Error: ${data.error}`);
            } else {
                setSuccess(true);
                setTimeout(() => setSuccess(false), 3000);
                setError('');
                setSaveEnabled(false);
            }
        } catch (err) {
            setError(`Error: ${err.message}`);
        }
    }
    return (
        <div className={classes.root}>
            <Grid container className={classes.grid} spacing={2}>
                <Grid item className={classes.gridItem} xs={12}>
                    {loading && <CircularProgress style={{alignSelf: 'center'}} />}
                </Grid>
                {error && <Grid item className={classes.gridItem} xs={12}>
                    <Alert severity="error">
                        <AlertTitle>Server Error</AlertTitle>
                        {error}
                    </Alert>
                </Grid>}
                <Grid item className={classes.gridItem} xs={12}>
                    <TextField id="gameweek" label="Gameweek" />
                </Grid>
                <Grid item className={classes.gridItem} xs={12}>
                    <Autocomplete disablePortal blurOnSelect
                        id="team-name"
                        options={squad}
                        style={{ width: 300 }}
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => <TextField {...params} label="Team" />} />
                </Grid>
                <Grid item className={classes.gridItem} xs={12}>
                    <TextField id="players" minRows={league ? league.teamSize : 11} multiline={true} placeholder="Paste eleven" />
                </Grid>
                <Grid item className={classes.gridItem} xs={12}>
                    <Button variant='contained' color='primary' onClick={validate} disabled={saveEnabled} style={{marginRight: '20px'}}>Validate</Button>
                    <Button variant='contained' color='primary' onClick={saveTeam} disabled={!saveEnabled}>Save</Button>
                    {success && <CheckIcon />}
                </Grid>
            </Grid>
        </div>
    )
}
export default withRouter(AuctionSubs)